//eos-uat环

const baseUrl = ''

const httpUrl = {
    configUrl: "",
    projectUrl: "",
    userUrl: "",
    paasUrl: "",
    // messageUrl: baseUrl+'/message/v1.0'
    messageUrl: "",
}
export default httpUrl
